import { IStore } from '../../store';
import { TAnnex6V2Actions } from './actions';
import { IAuthActions } from '../auth/actions';
import annex6V2HistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';

const annex6V2BaseMiddleware = createMiddleware<
    IStore,
    TAnnex6V2Actions | IAuthActions
>()
    .getMiddleware();

const annex6V2Middlewares = [
    annex6V2BaseMiddleware,
    annex6V2HistoryMiddleware,
];

export default annex6V2Middlewares;
